<template>
  <div id="app" v-cloak>
    <transition name="fade">
      <router-view/>
    </transition>
    <audio id="chatAudio"></audio>
    <el-collapse-transition v-if="showTam">
      <div class="tianmen" @click="hoverClear">
        <img src="/images/public/pnewyear.png" />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions,mapMutations} from 'vuex'
  export default {
    name: 'App',
    computed: {
      ...mapState(['userHeadInfo','newMessageInform', 'userLoginMessage','OrderDetail']),
      ...mapGetters(['userInfo','isGroup'])
    },
    methods: {
      ...mapMutations(['UPDATEUSERHEAD']),
      ...mapActions(['getUserHead','GetOrderDetail','updateNewMessage','getWaitHandleData','updateInfo','getStoreInfo','aGetOrderLists','searchOrder','hGetOrderLists','hGetOrderOffer','getUserIndexData','getStoreIndexData','getAdminDataLists']),
      // 语音支付金额播报
      speakWord(price_pay){
          let price_total=this.$options.filters['numberToChinese']((price_pay*1)/100);//小写转大学
          let speechSynthesis = new SpeechSynthesisUtterance();
          speechSynthesis.lang = "zh-CN"; // 设置语言
          speechSynthesis.volume = 1; // 设置说话的音量
          speechSynthesis.rate = 0.8; // 设置说话的速度(值越大语速越快,越小语速越慢)
          speechSynthesis.pitch = 0.6; // 设置话语的音调(值越大越尖锐,越低越低沉)
          speechSynthesis.text = "  订单雨到账"+price_total+"元"; // 设置说话时的文本
          window.speechSynthesis.speak(speechSynthesis)
      },
      updateData(type){
        // //重新获取条目数
        this.updateInfo(); 
        switch (type) {
            //更新编辑认证信息
            case 41:
              this.getStoreInfo();      
              this.getUserHead();  //更新会员头部信息
            break;
            //刷新酒店-管理员订单列表
            case 101:
            case 102:
            case 103:
            case 104:
                //103,104提交财务后更新财务管理待打款
                if(type==103&&this.userInfo.type==99||type==104&&this.userInfo.type==99){
                  let data={
                    page:1
                  }
                  this.getAdminDataLists({
                    data:data,
                    type:'PaymentList',
                  });
                };
            default:
              break;
          }
      },
      clear () {
        this.gqtimer1 = setTimeout(() => {
          this.showTam = false;
          window.localStorage.setItem('seeAnimateTime',(new Date()).getTime())
          clearInterval(this.gqtimer)
          clearTimeout(this.gqtimer1)
        },5000);
      },
      hoverClear () {
        this.showTam = false;
        window.localStorage.setItem('seeAnimateTime',(new Date()).getTime())
        clearInterval(this.gqtimer)
        clearTimeout(this.gqtimer1)
      },
      //更新用户信息
      updateInfo(){
        let s = this.userLoginMessage;
        let num = s.uid||s.id;
        // if(s.type==3) {
        //   this.updateInfo();
        // }
        if (s.socketType) this.$connSocket(this.WS_URL, s.socketType, num);
        if(s.type==2||s.storeId>0||s.type==99||s.verify||this.isGroup){
          this.getUserIndexData(); 
        } 
      }
    },
    mounted () {
      let now = Math.round(new Date() / 1000)
      if (now >= 1579708800 && now <= 1580486399) {
        let today = new Date(new Date().toLocaleDateString()).getTime()
        if (window.localStorage.hasOwnProperty("seeAnimateTime")) {
          if (Number(window.localStorage.getItem('seeAnimateTime')) < today) {
            this.gqtimer = setInterval(() => {
              this.showTam = true
            }, 60)
          }
        } else {
          this.gqtimer = setInterval(() => {
            this.showTam = true
          }, 60)
        }
        this.clear()
      }
    },
    created () {
      window.localStorage.removeItem('userMessage');  //删除重构之前的localStorage
      if(!window.localStorage.getItem('VERSION')){
              window.localStorage.setItem('VERSION', JSON.stringify(this.VERSION));   //存储版本号
      }
      //当在任一路由页面被刷新时,即是根组件app被重新创建,是登录状态则可以进行webSocket重连
      //通过认证的用户刷新时会调取用户信息，认证中的用户不调用
      this.updateInfo();

    },
    data () {
      return {
        audioArr: [
          { type: '2', src: ' /audio/userVerify.mp3' },          //用户注册待处理
          { type: '3', src: ' /audio/verifyEnd.mp3' },           //用户认证待处理
          { type: '4', src: ' /audio/player.mp3' },              //住宿订单待审核
          { type: '5', src: ' /audio/player.mp3' },              //采购商订单审核通过
          { type: '24', src: '/audio/commentVerify.mp3' },       //评论待审核
          { type: '25', src: '/audio/newOrder.mp3' },            //管理员有新的待确认订单
          { type: '8', src: ' /audio/newOrder.mp3' },            //景区、民宿有新的待确认订单
          { type: '26', src: '/audio/homestayOrderPay.mp3' },    //民宿确认采购商订单
          { type: '6', src: ' /audio/waitOffer.mp3' },           //酒店待报价订单
          { type: '7', src: ' /audio/waitCheckOffer.mp3' },      //采购商有新的报价
          { type: '30', src: '/audio/agreeCheckIn.mp3' },        //采购商住宿订单成交
          { type: '32', src: '/audio/vocation.mp3' },            //度假产品订单成交
          { type: '33', src: '/audio/roomtype.mp3' },            //房态提交
          { type: '37', src: '/audio/brand.mp3' },               //品牌馆订单
          { type: '39', src: '/audio/TravelConfirm.mp3'},        //采购商修改订单后给选中酒店发消息
          { type: '40', src: '/audio/HotelConfirm.mp3'},         //酒店确认修改订单后给自己和采购商发消息
          { type: '41', src: '/audio/verifyEnd.mp3' },           //编辑认证
          { type: '42', src: '/audio/TravelEdit.mp3'},           //酒店修改订单后发给采购商发单人的通知
          { type: '43', src: '/audio/HotelEdit.mp3'},            //采购商确认修改订单后发给酒店报价人的通知
        ],
        showTam: false,
        gqtimer: null,
        gqtimer1: null,
        userMessage: JSON.parse(window.localStorage.getItem('userLoginMessage')) || {},
        isShowAlert:false,            //是否已弹出提示框
      }
    },
    watch: {
      newMessageInform (newVal) {
          this.$notify({
            title: this.newMessageInform.title,
            message: this.newMessageInform.content,
            position: 'bottom-right'
          })
          //认证不需要执行updateData;
          if(newVal.type!=3){
            this.updateData(newVal.type);
          }
          //播放收款语音
          if(newVal.type==101&&this.userInfo.type!=2){
            this.speakWord(newVal.money)
          }
          //酒店增加余额
          if(this.userInfo.type==3&&newVal.type==101){
            this.userHeadInfo.money+=newVal.money;
            this.UPDATEUSERHEAD(this.userHeadInfo);
            }
          //酒店减去余额
          if(this.userInfo.type==3&&newVal.type==102){
            this.userHeadInfo.money-=newVal.money;
            this.UPDATEUSERHEAD(this.userHeadInfo);
          }
          //管理员待审核通知
          this.audioArr.forEach(item => {
            if (item.type == newVal.type) {
              $('#chatAudio').attr('src', item.src)
              $('#chatAudio')[0].play().catch(() => {
                //认证不弹出以免冲突提示
                if(newVal.type!=3){
                  if(!this.isShowAlert){
                    this.isShowAlert=true;
                    this.$message({
                      message: '未开启新订单声音提示，请点击确定开启提示功能',
                      type: 'warning'
                    });
                    // this._alert('未开启新订单声音提示，请点击确定开启提示功能',() => {
                    //   this.isShowAlert=false;
                    // },'info')
                  }
                   
                }
              })
            }
          })
        }
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 14px;
  }
  [v-cloak] {
    display:none !important;
  }
  .delete{
    color: #999999;
  }
  .flag{
    color: #fe8800;
  }
  .red{
    color: #dc3545;
  }
  .Orange{
    color: #ffa800;
  }
  .green{
    color: #09af09;
  }
  .greys{
    color: #1760fb;
  }
  .purple{
    color: #c811df;
  }

  .resize-none textarea{
        resize: none;
        height: 90px;
        font-family: '微软雅黑';
  }
  .jzk .el-loading-mask{
    background-color: initial;
  }
  .drawer .el-drawer__header{
        margin-bottom: 0;
  }
</style>
